/*
 * @Date: 2023-10-30 19:39:32
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-06-27 09:44:40
 * @FilePath: /Client/src/plugins/cache.ts
 * @Description:
 */
import dayjs from 'dayjs'
import { getCookie } from '@/plugins/utils'
import Cookie from 'js-cookie'
import { getQueryParams } from './tripartite-login'
import { useSite2Station } from '@/store'
let appid: string
const version = '13'
const env = process.env.NODE_ENV === 'production' ? '.theckb.com' : 'localhost'
export const appEnv = process.env.VUE_APP_ENV + '_'

/**
 * 判断是否是h5商品详情推广页跳转过来的
 * 如果是的就还要跳转回去
 */
const checkIfh5GoodsDetailPromotion = () => {
  const fromUrl = (() => {
    // 先看 url 上有米有
    let _formUrl = getQueryParams().from as string
    if (_formUrl) return _formUrl
    // 如果是三方登录跳转来的 会在 localStorage 中有
    const TO_AUTH_PAGE_URL = localStorage.getItem('TO_AUTH_PAGE_URL')
    if (!TO_AUTH_PAGE_URL) return undefined
    // 有的话删掉 不要污染其他页面
    localStorage.removeItem('TO_AUTH_PAGE_URL')
    _formUrl = getQueryParams(TO_AUTH_PAGE_URL).from
    return _formUrl
  })()
  const stationCode = useSite2Station()
  //   如果是代采的h5，直接跳转首页 h5只支持日本站
  if (fromUrl === 'ckbh5' && stationCode === 'JapanStation') {
    window.location.href = '/h5/promotion/home'
    return true
  }
  //   h5只支持日本站
  if (fromUrl?.includes('/h5/promotion/goodsDetail') && stationCode === 'JapanStation') {
    // 不延迟也没问题?
    setTimeout(() => {
      window.location.href = fromUrl
    }, 1000)
    return true
  }
  return false
}

const saveCookieList = ['route/token', 'route/plat']
const caches = {
  init (val = process.env.NODE_ENV): void {
    appid = val + '_'
    if (localStorage.__VERSION !== version) {
      localStorage.clear()
      localStorage.__VERSION = version
    }
  },
  set (k: string, val: any, expire: number | void): void {
    if (typeof val === 'function') {
      val = {
        $fn: true,
        val: val.toString(),
        expire: expire || null
      }
    } else {
      val = {
        val,
        expire: expire || null
      }
    }
    localStorage[appid + k] = JSON.stringify(val)
    if (saveCookieList.includes(k)) {
      // console.log('k, val', k, val)
      if (val.val) {
        Cookie.set(appEnv + k, val.val, { path: '/', domain: env, expires: val.expire && val.val ? new Date(val.expire) : new Date() })
        // 判断是否是h5商品详情推广页跳转过来的 如果是的就还要跳转回去
        checkIfh5GoodsDetailPromotion()
      } else {
        Cookie.remove(appEnv + k, { path: '/', domain: env })
      }
    }
  },
  get (k: string): any {
    const { expire, val, $fn } = JSON.parse(localStorage[appid + k] || '{}')
    if ((!Cookie.get(appEnv + k)) && saveCookieList.includes(k)) {
      return ''
    }
    if (expire && dayjs(expire).isBefore(dayjs())) {
      this.delete(k)
      if (saveCookieList.includes(k)) {
        Cookie.remove(appEnv + k, { path: '/', domain: env })
      }
    } else {
      if ($fn) {
      } else {
        if ((Cookie.get(appEnv + k)) && saveCookieList.includes(k)) {
          if (val) {
            return val
          } else {
            return (Cookie.get(appEnv + k))
          }
        }
        return val
      }
    }
  },

  delete (k: string): void {
    delete localStorage[appid + k]
  },
  getAll (): any {
    const reg = new RegExp('^' + appid)
    return Object.keys(localStorage)
      .filter((k) => reg.test(k))
      .map((k) => [(k = k.replace(appid, '')), this.get(k)])
  }
}
export default caches

//
export const createProxy = (state: any, local:any, expire: number | void) => {
  return new Proxy(state, {
    get (target, key: string) {
      if (local[key]) {
        return caches.get(key) ?? target[key]
      } else {
        return target[key]
      }
    },
    set (target, key: string, val) {
      if (local[key]) {
        caches.set(key, val, expire)
      }
      target[key] = val
      return val
    }
  })
}
